import { render, staticRenderFns } from "./TenantContract.vue?vue&type=template&id=587cdd34&"
import script from "./TenantContract.vue?vue&type=script&lang=js&"
export * from "./TenantContract.vue?vue&type=script&lang=js&"
import style0 from "./TenantContract.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports